module.exports = __webpack_public_path__ + "img/align-left.7f4fcfd1.svg";